import { createReducer } from '@reduxjs/toolkit';
import { persistReducer, purgeStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTableStateReducers } from '@/store/tableState.reducer';
import t from '@/store/types';

export const defaultTableQueryState = {
  pageSize: 20,
  pageIndex: 0,
  inactiveMode: false,
  filterRoles: [],
  viewSlug: null,
};

const initialState = {
  tableState: defaultTableQueryState,
  selectedRows: [],
};

const STORAGE_KEY = 'leyona:vendors';

const CONFIG = {
  key: STORAGE_KEY,
  whitelist: [],
  storage,
};

const reducerInstance = createReducer(initialState, (builder) => {
  Object.entries(
    createTableStateReducers('VENDORS', defaultTableQueryState),
  ).forEach(([actionType, reducer]) => {
    builder.addCase(actionType, reducer);
  });

  builder.addCase('VENDORS/SET_SELECTED_ROWS', (state, action: any) => {
    state.selectedRows = action.payload;
  });

  builder.addCase('VENDORS/RESET_SELECTED_ROWS', (state) => {
    state.selectedRows = [];
  });

  builder.addCase(t.RESET, () => {
    purgeStoredState(CONFIG);
    return initialState;
  });
});

export default persistReducer(CONFIG, reducerInstance);
